import React, { Component } from 'react'
import { Dialog } from "@material-ui/core"
import './OtherRatioDialog.scss'
import i18n from '@/i18n'
import Validator from "@/utils/Validator"
import UnavailableDialog from './UnavailableDialog/UnavailableDialog'
import { connect } from 'react-redux'
import DataManager from "@/utils/DataManager";
import { TemplatesApis } from "@/utils/Videomonster/Apis"
import { ErrorHandler } from '@/utils/Error/Handler'

const RATIO_IMG = {
    '16:9': "https://front.videomonster.com/images-7cuytg20/web/myvideo/16to9.svg",
    '9:16': "https://front.videomonster.com/images-7cuytg20/web/myvideo/9to16.svg",
    '1:1': "https://front.videomonster.com/images-7cuytg20/web/myvideo/1to1.svg",
    '4:5': "https://front.videomonster.com/images-7cuytg20/web/myvideo/4to5.svg"
}

const PLATFORM = {
    '16:9': {
        platform: ['Youtube'],
        imgSrc: ["https://front.videomonster.com/images-7cuytg20/web/myvideo/youtube.webp"]
    },
    '9:16': {
        platform: ['Instagram Reels, TikTok'],
        imgSrc: ["https://front.videomonster.com/images-7cuytg20/web/myvideo/instagram-reels.webp", "https://front.videomonster.com/images-7cuytg20/web/myvideo/tiktok.webp"]
    },
    '1:1': {
        platform: ['Facebook, Instagram'],
        imgSrc: ["https://front.videomonster.com/images-7cuytg20/web/myvideo/facebook.svg", "https://front.videomonster.com/images-7cuytg20/web/myvideo/instagram.webp"]
    },
    '4:5': {
        platform: ['Instagram'],
        imgSrc: ["https://front.videomonster.com/images-7cuytg20/web/myvideo/instagram.webp"]
    }
}

const STANDARD_RATIO = ['16:9', '1:1', '9:16', '4:5'];

class OtherRatioDialog extends Component {
    state = {
        selectedRatio: '9:16',
        curRatio: null,
        groupData: undefined,
        ratioArr: [],
        isUnavailableDialogOpen: false,
    }

    componentDidUpdate = (prevProps) => {
        const { open } = this.props;
        if (open && open !== prevProps.open) {
            this.getGroupInfo()
        }
    }

    getGroupInfo = async () => {
        const { selectedVideo } = this.props;
        const templateId = selectedVideo.template._id
        try {
            if (templateId) {
                const token = DataManager.GetToken();
                const { result, data } = await TemplatesApis.GetGroupRatioChange(token, { templateId });
                if (!result || !data) {
                    this.handleUnavailableDialogOpen(data);
                    return;
                }

                const groupData = data
                let key
                for (let curKey in groupData) {
                    if (groupData[curKey]._id === templateId) {
                        key = curKey
                        break
                    }
                }

                const ratioArr = Object.keys(groupData).filter(item => groupData[item].isSupported && item !== key)
                if (!ratioArr.length) {
                    this.handleUnavailableDialogOpen();
                    return;
                }
                const selectedRatio = STANDARD_RATIO.filter(item => ratioArr.includes(item))[0]
                this.setState({ groupData, curRatio: key, ratioArr, selectedRatio })
            }
        } catch (e) {
            this.props.onClose();
            ErrorHandler(this, null, e, { server: true, alert: true })
        }
    }

    handelClickRatio = ratio => { this.setState({ selectedRatio: ratio }) }

    renderPlatform = (ratio) => {
        const platformImg = PLATFORM[ratio]['imgSrc'].map(img => {
            return (
                <img src={img} alt='' />
            )
        })

        const platformName = PLATFORM[ratio]['platform']

        return (
            <>
                <div className='platform-img'>{platformImg}</div>
                <div className='platform-name'>{i18n.t("myvideo.changeratio.platform.des").replace('{platform}', platformName)}</div>
            </>
        )
    }

    renderRatio = (ratio) => {
        const { selectedRatio } = this.state

        return (
            <div className={`ratio-area ${selectedRatio === ratio && 'selected'}`} onClick={() => this.handelClickRatio(ratio)}>
                <div className='ratio-left-area'>
                    <div className='ratio'><img src={RATIO_IMG[ratio]} alt='' /></div>
                </div>
                <div className='ratio-right-area'>
                    <div className='fit-platform'>
                        {this.renderPlatform(ratio)}
                    </div>
                </div>
            </div>
        )
    }
    
    handleChangeRatioVideo = () => {
        const { selectedRatio, groupData } = this.state;
        const { onChangeRatioVideo, onClose, selectedVideo } = this.props;
        const selectedRatioId = groupData[selectedRatio]._id;
        
        onClose();
        onChangeRatioVideo(selectedVideo._id, selectedRatioId);
    }

    renderRightButton = () => {
        const { paymentMode, currentUser, coupons, history } = this.props
        const provider = DataManager.GetProvider()
        const isValidBundleCoupon = coupons ? coupons.some((item) => DataManager.IsValidCoupon(item, provider)) : false;
        const isCafe24 = DataManager.IsProvider(DataManager.PROVIDER.CAFE24);
        
        if(currentUser){
            if (currentUser.admin || paymentMode) {return <div onClick={this.handleChangeRatioVideo} className='btn right'>{i18n.t("myvideo.changeratio.edit")}</div>}
            else if (isValidBundleCoupon && isCafe24) return <div onClick={this.handleChangeRatioVideo} className='btn right'>{i18n.t("myvideo.changeratio.coupon")}</div>
            else return <div onClick={() => history.push("/payment")} className='btn right'>{i18n.t("myvideo.changeratio.paymentbtn")}</div>
        }
       
    }

    handleUnavailableDialogOpen = () => {
        this.props.onClose();
        this.setState({ isUnavailableDialogOpen: true })
    }

    render() {
        const { ratioArr, isUnavailableDialogOpen, groupData, selectedRatio } = this.state
        const { open, onClose } = this.props;
        return (
            <>
                <Dialog open={Validator.ArrayNotEmpty(ratioArr) && open} onClose={onClose} maxWidth={"lg"}>
                    <div className='other-ratio-dialog-root'>
                        <div className='close' onClick={onClose}><img src='https://front.videomonster.com/images-7cuytg20/web/videoDialog/close_icon.svg' alt='' /></div>
                        <div className='video-area'>
                            <video muted src={groupData && groupData[selectedRatio].previewURL} controls controlsList='nodownload' autoPlay>Your browser does not support the video tag.</video>
                        </div>
                        <div className='other-ratio-container'>
                            <div className='other-ratio-area'>
                                <div className='other-ratio-title-area'>
                                    <div className='select-other-ratio-title'>{i18n.t("myvideo.changeratio.title")}</div>
                                    <div className='select-other-ratio-subtitle'>{i18n.t("myvideo.changeratio.subtitle")}</div>
                                    <div className='select-other-ratio-des'>{i18n.t("myvideo.changeratio.des")}</div>
                                </div>
                                <div className='other-ratio-select-area'>
                                    {
                                        STANDARD_RATIO.filter(item => ratioArr.includes(item)).map(ratio => {
                                            return (
                                                this.renderRatio(ratio)
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div className='other-ratio-btn-area'>
                                <div className='btn left' onClick={onClose}>{i18n.t("global.cancel")}</div>
                                {/* <div className='btn right'>{i18n.t("myvideo.changeratio.paymentbtn")}</div> */}
                                {this.renderRightButton()}
                            </div>
                        </div>
                    </div>
                </Dialog>
                <UnavailableDialog
                    open={isUnavailableDialogOpen}
                    onClose={() => this.setState({ isUnavailableDialogOpen: false, errorCode: null })}
                />
            </>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.userStore.user,
    paymentMode: state.paymentModeStore.paymentMode,
    coupons: state.couponStore.coupons,
})

export default connect(mapStateToProps, null)(OtherRatioDialog)